// action types
import { createRequestTypes } from "../../utils";

// Fetch Products (list)
export const FETCH_ADMIN_PRODUCTS = createRequestTypes("FETCH_ADMIN_PRODUCTS");

export const fetchAdminProductsRequest = (filters = {}) =>
    ({ type: FETCH_ADMIN_PRODUCTS.REQUEST, payload: { filters } });

export const fetchAdminProductsSuccess = (data) =>
    ({ type: FETCH_ADMIN_PRODUCTS.SUCCESS, payload: { data } });

export const fetchAdminProductsFailure = (error) =>
    ({ type: FETCH_ADMIN_PRODUCTS.FAILURE, payload: error });

// Fetch Single Product
export const FETCH_ADMIN_PRODUCT = createRequestTypes("FETCH_ADMIN_PRODUCT");

export const fetchAdminProductRequest = (id) =>
    ({ type: FETCH_ADMIN_PRODUCT.REQUEST, payload: { id } });

export const fetchAdminProductSuccess = (data) =>
    ({ type: FETCH_ADMIN_PRODUCT.SUCCESS, payload: { data } });

export const fetchAdminProductFailure = (error) =>
    ({ type: FETCH_ADMIN_PRODUCT.FAILURE, payload: error });

// Create Product
export const CREATE_PRODUCT = createRequestTypes("CREATE_PRODUCT");

export const createProductRequest = (data, onSuccess) =>
    ({ type: CREATE_PRODUCT.REQUEST, payload: { data, onSuccess } });

export const createProductSuccess = (data) =>
    ({ type: CREATE_PRODUCT.SUCCESS, payload: { data } });

export const createProductFailure = (error) =>
    ({ type: CREATE_PRODUCT.FAILURE, payload: error });

// Update Product
export const UPDATE_PRODUCT = createRequestTypes("UPDATE_PRODUCT");

export const updateProductRequest = (id, data, onSuccess) =>
    ({ type: UPDATE_PRODUCT.REQUEST, payload: { id, data, onSuccess } });

export const updateProductSuccess = (data) =>
    ({ type: UPDATE_PRODUCT.SUCCESS, payload: { data } });

export const updateProductFailure = (error) =>
    ({ type: UPDATE_PRODUCT.FAILURE, payload: error });

// Delete Product
export const DELETE_PRODUCT = createRequestTypes("DELETE_PRODUCT");

export const deleteProductRequest = (id, onSuccess) =>
    ({ type: DELETE_PRODUCT.REQUEST, payload: { id, onSuccess } });

export const deleteProductSuccess = (id) =>
    ({ type: DELETE_PRODUCT.SUCCESS, payload: { id } });

export const deleteProductFailure = (error) =>
    ({ type: DELETE_PRODUCT.FAILURE, payload: error });

// Upload Product Images
export const UPLOAD_PRODUCT_IMAGES = createRequestTypes("UPLOAD_PRODUCT_IMAGES");

export const uploadProductImagesRequest = (productId, images, onSuccess) =>
    ({ type: UPLOAD_PRODUCT_IMAGES.REQUEST, payload: { productId, images, onSuccess } });

export const uploadProductImagesSuccess = (data) =>
    ({ type: UPLOAD_PRODUCT_IMAGES.SUCCESS, payload: { data } });

export const uploadProductImagesFailure = (error) =>
    ({ type: UPLOAD_PRODUCT_IMAGES.FAILURE, payload: error });

// Delete Product Image
export const DELETE_PRODUCT_IMAGE = createRequestTypes("DELETE_PRODUCT_IMAGE");

export const deleteProductImageRequest = (productId, imageId, onSuccess) =>
    ({ type: DELETE_PRODUCT_IMAGE.REQUEST, payload: { productId, imageId, onSuccess } });

export const deleteProductImageSuccess = (productId, imageId) =>
    ({ type: DELETE_PRODUCT_IMAGE.SUCCESS, payload: { productId, imageId } });

export const deleteProductImageFailure = (error) =>
    ({ type: DELETE_PRODUCT_IMAGE.FAILURE, payload: error });

// Fetch Presentations for a product
export const FETCH_PRESENTATIONS = createRequestTypes("FETCH_PRESENTATIONS");

export const fetchPresentationsRequest = (productId) =>
    ({ type: FETCH_PRESENTATIONS.REQUEST, payload: { productId } });

export const fetchPresentationsSuccess = (data) =>
    ({ type: FETCH_PRESENTATIONS.SUCCESS, payload: { data } });

export const fetchPresentationsFailure = (error) =>
    ({ type: FETCH_PRESENTATIONS.FAILURE, payload: error });

// Create Presentation
export const CREATE_PRESENTATION = createRequestTypes("CREATE_PRESENTATION");

export const createPresentationRequest = (data, onSuccess) =>
    ({ type: CREATE_PRESENTATION.REQUEST, payload: { data, onSuccess } });

export const createPresentationSuccess = (data) =>
    ({ type: CREATE_PRESENTATION.SUCCESS, payload: { data } });

export const createPresentationFailure = (error) =>
    ({ type: CREATE_PRESENTATION.FAILURE, payload: error });

// Update Presentation
export const UPDATE_PRESENTATION = createRequestTypes("UPDATE_PRESENTATION");

export const updatePresentationRequest = (id, data, onSuccess) =>
    ({ type: UPDATE_PRESENTATION.REQUEST, payload: { id, data, onSuccess } });

export const updatePresentationSuccess = (data) =>
    ({ type: UPDATE_PRESENTATION.SUCCESS, payload: { data } });

export const updatePresentationFailure = (error) =>
    ({ type: UPDATE_PRESENTATION.FAILURE, payload: error });

// Delete Presentation
export const DELETE_PRESENTATION = createRequestTypes("DELETE_PRESENTATION");

export const deletePresentationRequest = (id, onSuccess) =>
    ({ type: DELETE_PRESENTATION.REQUEST, payload: { id, onSuccess } });

export const deletePresentationSuccess = (id) =>
    ({ type: DELETE_PRESENTATION.SUCCESS, payload: { id } });

export const deletePresentationFailure = (error) =>
    ({ type: DELETE_PRESENTATION.FAILURE, payload: error });

// Clear current product
export const CLEAR_CURRENT_PRODUCT = "CLEAR_CURRENT_PRODUCT";

export const clearCurrentProduct = () =>
    ({ type: CLEAR_CURRENT_PRODUCT });
